import { render, staticRenderFns } from "./DepositNotif.vue?vue&type=template&id=923a2eb0&"
import script from "./DepositNotif.vue?vue&type=script&lang=js&"
export * from "./DepositNotif.vue?vue&type=script&lang=js&"
import style0 from "./DepositNotif.vue?vue&type=style&index=0&id=923a2eb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports